import { css, html, LitElement } from "lit-element/lit-element.js";
import { customElement } from "lit/decorators/custom-element.js";
import { TwoColumnElementModel, TwoColumnSettingsElementModel } from "../../api/ContentDeliveryApi.schemas";
import { UmbracoPage } from "../../ContentLoader";
import { renderElement } from "../../RenderElement";

@customElement('lindberg-two-column')
export class TwoColumn extends LitElement {
    static styles = css`
        :host {
            box-sizing: border-box;
            display: grid;
            grid-template-columns: repeat(12, 1fr);

            gap: var(--grid-gutter);

            /* padding: var(--space-100); */
            /* width: 100vw; */

            .column-left, .column-right {
                display: flex;
                grid-column: span 6;
                * {
                    width: 100%;
                }
            }
            .column-right {
                text-align: right;
            }
           
            @media (width < 600px) {
                grid-template-columns: repeat(4, 1fr);

                grid-auto-flow: row;

                .column-left, .column-right {
                    grid-column: span 4;
                    flex-direction: column;
                    gap: var(--elements-box-margins);
                }
                .column-right {
                    text-align: left;
                }
            }
        }

        @media (width < 600px) {
            :host(.right-first) .column-right{
                order: -1;
            }
        }

        :host(.middle){
            align-items: center;
        }
        :host(.bottom){
            align-items: end;
        }

        :host(.featured-media) {
            align-items: end;

            .column-left, .column-right {
                display: contents;
            }

            /*Main Image*/
            & > .column-left > :first-child {
                grid-column: 1 / span 8;
                @media (width < 600px) {
                    grid-column: 1 / -1;
                }
            }

            /* Text Content */
            & > .column-left > *:not(:first-child) {
                grid-row: 2;

                @media (width >= 1160px) {
                    grid-column: 5 / span 4;
                }
                
                @media (912px <= width < 1160px) {                 
                    grid-column: 3 / span 6;
                }

                @media (600px <= width < 912px) { 
                    grid-column: 1 / span 8;
                }

                @media (width < 600px) {
                    grid-column: 1 / -1;
                    grid-row: 2;
                }                
            }

            /* Right Content */
            & > .column-right > *  {
                grid-column: 9 / span 4;
                grid-row: 1 / span 2;
                align-self: end;
                @media (width < 600px) {
                    grid-column: 2 / -1;
                    grid-row: 3;
                }
            }
        }
        @media (width >= 600px) {
            :host(.col-8-4) {
                & > .column-left {
                    grid-column: span 8;
                }
                & > .column-right {
                    grid-column: span 4;
                }
            }

            :host(.col-4-8) {
                & > .column-left {
                    grid-column: span 4;
                }
                & > .column-right {
                    grid-column: span 8;
                }
            }

            :host(.col-6-5){
                & > .column-left {
                    grid-column: span 6;
                }
                & > .column-right {
                    grid-column: 8 / span 5;
                    flex-direction: column;
                    gap: var(--elements-box-margins);

                }
            }
            :host(.col-5-5){
                & > .column-left {
                    grid-column: span 5;
                }
                & > .column-right {
                    grid-column: 8 / span 5;
                }
            }

            :host(.no-gap){
                --grid-gutter: 0px;
            }
        }
    `

    private _data!: { content: TwoColumnElementModel; settings?: TwoColumnSettingsElementModel }
    root!: UmbracoPage;

    get data() {
        return this._data;
    }

    set data(value: { content: TwoColumnElementModel; settings?: TwoColumnSettingsElementModel }) {
        this._data = value;
        // console.log('TwoColumn', value.content, value.settings)
        if(this.data.settings?.properties?.variant)this.classList.add(this.data.settings?.properties?.variant)
        if(this.data.settings?.properties?.mobileOrder)this.classList.add(`${this.data.settings?.properties?.mobileOrder.toLowerCase()}-first`)
        this.data.settings?.properties.contentAlign?.split(' ').filter(x => x).forEach(x => this.classList.add(x))
    }
        
    connectedCallback() {
        super.connectedCallback()
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
    }
    
    render = () => html`
        <div class="column-left">
            ${this.data.content.properties.left?.items.map(x => renderElement(x, this.root))}
        </div>
        <div class="column-right">
            ${this.data.content.properties.right?.items.map(x => renderElement(x, this.root))}
        </div>
    `
}